import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { postData } from "../../services/generalService";
import { ChargeReversalResponseBodyObj } from "../../utils/types";

const initialState: ChargeReversalResponseBodyObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const postChargeReversalTransaction = createAsyncThunk(
  "loans/postChargeReversalTransaction",
  async (formData: { url: string; postsData: {} }, thunkAPI) => {
    const { url, postsData } = formData;
    try {
      const data = await postData(url, postsData, true);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const postChargeReversalTransactionSlice = createSlice({
  name: "postChargeReversalTransaction",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postChargeReversalTransaction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postChargeReversalTransaction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(postChargeReversalTransaction.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default postChargeReversalTransactionSlice.reducer;
